export { default } from './lint-staged.js';
